import { useEffect, useState } from "react";
import { Col, Row, Table, FormInstance, Space, Card } from 'antd';
import { ExpandAltOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { AlignType } from 'rc-table/lib/interface';
import { errorMessage } from "../../../utils/messages";

import { converterCargo, ICargoConsulta, IMandatoDirigenteConsulta } from "../../Mandato/Componentes/InterfaceMandato";
import { apiCand } from "../../../services/apiCand";
import { IOutroCargoConsulta } from "../../OutroCargo/Componentes/InterfaceOutroCargo";
import { IDirigenteExcepcionalConsulta } from "../../DirigenteExcepcional/Componentes/InterfaceDirigenteExcepcional";

interface IProps {
  form: FormInstance<any>;
  mandatosDirigentes: IMandatoDirigenteConsulta[];
  outrosCargos: IOutroCargoConsulta[];
  dirigentesExcepcionais: IDirigenteExcepcionalConsulta[];
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
}

const PessoaFisicaCargoMandato = ({ form, mandatosDirigentes, outrosCargos, dirigentesExcepcionais, manter }: IProps) => {
  const navigate = useNavigate();

  const [loading2, setLoading2] = useState(false);


  const [mandatosDirigentesFull, setMandatosDirigentesFull] = useState([]);
  const [outrosCargosFull, setOutrosCargosFull] = useState([]);
  const [dirigentesExcepcionaisFull, setDirigentesExcepcionaisFull] = useState([]);
  const [consulta, setConsulta] = useState<ICargoConsulta[]>([]);

  useEffect(() => {
    let items = converterCargo(mandatosDirigentes, outrosCargos, dirigentesExcepcionais);
    setConsulta(items);
  }, [mandatosDirigentes, outrosCargos, dirigentesExcepcionais])


  useEffect(() => {
    if (mandatosDirigentesFull.length !== 0) {
      pushToManterMandatoDirigente(mandatosDirigentesFull, 2);
    }
    else if (outrosCargosFull.length !== 0)
      pushToManterOutroCargo(outrosCargosFull, 2);
    else if (dirigentesExcepcionaisFull.length !== 0)
      pushToManterDirigenteExcepcional(dirigentesExcepcionaisFull, 2);
  }, [mandatosDirigentesFull, outrosCargosFull, dirigentesExcepcionaisFull]);

  function pushToManterMandatoDirigente(manDir: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: manDir
    }
    if (manDir.csCategoria === 1) { // DIRETOR
      navigate("/dirigente/diretor/manter", { state: tpSelecao });
    } else if (manDir.csCategoria === 2 || manDir.csCategoria === 3) { // CONSELHEIRO
      navigate("/dirigente/conselheiro/manter", { state: tpSelecao });
    }
  }

  function pushToManterOutroCargo(oc: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: oc
    }
    navigate("/outro-cargo/manter", { state: tpSelecao });
  }

  function pushToManterDirigenteExcepcional(oc: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: oc
    }
    navigate("/dirigente-excepcional/manter", { state: tpSelecao });
  }

  const getMandatoDirigentePorId = async (idMandato: number, csCategoria: number) => {
    try {
      setLoading2(true);
      if (csCategoria === 1) { // DIRETOR
        let lQuery = `mandatodiretor/${idMandato}`;
        const { data } = await apiCand.get(lQuery);
        setMandatosDirigentesFull(data);
      } else if (csCategoria === 2 || csCategoria === 3) { // CONSELHEIRO
        let lQuery = `mandatoconselheiro/${idMandato}`;
        const { data } = await apiCand.get(lQuery);
        setMandatosDirigentesFull(data);
      }
    } catch (error:any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading2(false);
    }
  };

  const getOutroCargoPorId = async (idOutroCargo: number) => {
    try {
      setLoading2(true);
      let lQuery = `outroCargo/${idOutroCargo}`;
      const { data } = await apiCand.get(lQuery);
      setOutrosCargosFull(data);
    } catch (error:any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading2(false);
    }
  };

  const getDirigenteExcepcionalPorId = async (idDirExcepcional: number) => {
    try {
      setLoading2(true);
      let lQuery = `dirigenteExcepcional/${idDirExcepcional}`;
      const { data } = await apiCand.get(lQuery);
      setDirigentesExcepcionaisFull(data);
    } catch (error:any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading2(false);
    }
  };

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Entidade",
      dataIndex: "",
      render: (ICargoMandato: ICargoConsulta) => <>{ICargoMandato.sigla?.toUpperCase()}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Cargo/Mandato",
      dataIndex: "",
      render: (ICargoMandato: ICargoConsulta) => <>{ICargoMandato.nmCargoMandato?.toUpperCase()}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data Inicial",
      dataIndex: "",
      render: (ICargoMandato: ICargoConsulta) => <>{dayjs(ICargoMandato.dtInicio).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data Final",
      dataIndex: "",
      render: (ICargoMandato: ICargoConsulta) => <>{ICargoMandato.dtFim ? dayjs(ICargoMandato.dtFim).format("DD/MM/YYYY") : " ATÉ O MOMENTO"}</>,
    },
    {
      key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ICargoMandato: ICargoConsulta) =>
        <div style={{display: manter && manter === 9 ? "none" : "inline" }}>
          <Space style={{justifyContent: 'center'}}>
            <ExpandAltOutlined
              title="Detalhar dirigente"
              style={{ color: "blue", display: (ICargoMandato.idMandato > 0) ? "inline" : "none" }}
              // shape="round"
              id='detalhar-dirigente'
              onClick={() => {
                getMandatoDirigentePorId(ICargoMandato.idMandato, ICargoMandato.csCategoria);
              }}
            />

            <ExpandAltOutlined
              title="Detalhar outro cargo"
              style={{ color: "blue", display: (ICargoMandato.idOutroCargo > 0) ? "inline" : "none" }}
              // shape="round"
              id='detalhar-outro-cargo'
              onClick={() => {
                getOutroCargoPorId(ICargoMandato.idOutroCargo);
              }}
            />

            <ExpandAltOutlined
              title="Detalhar dirigente excepcional"
              style={{ color: "blue", display: (ICargoMandato.idDirExcepcional > 0) ? "inline" : "none" }}
              // shape="round"
              id='detalhar dirigente-excepcional'
              onClick={() => {
                getDirigenteExcepcionalPorId(ICargoMandato.idDirExcepcional);
              }}
            />

          </Space>

        </div>
    }
  ];

  return (
    <>
      <Card loading={loading2}>
        <Row >
          <Col
            xs={24}
            xl={24}
            style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
          >
            <Table size="small" columns={columns} dataSource={consulta} pagination={false} />
          </Col>
        </Row>
      </Card>
    </>
  )
};

export default PessoaFisicaCargoMandato;